import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('fieldFormFields');

    return {
        CLIENT_NAME_FIELD_PLACEHOLDER: t('clientNameFieldPlaceholder'),
        FARM_NAME_FIELD_PLACEHOLDER: t('farmNameFieldPlaceholder'),
        FIELD_NAME_FIELD_PLACEHOLDER: t('fieldNameFieldPlaceholder'),
        LABEL: t('label')
    };
};

export default useTranslation;
